export const errorMessages = {
  REFRESH_TOKEN_NOT_FOUND: 'refresh token not found.',
  REFRESH_TOKEN_EXPIRED: 'refresh token expired',
  NO_AUTH_TOKEN: 'No auth token',
};
